import type { AppSource } from "@/types/application";

export type AppSourceVariant = "default" | "secondary" | "outline" | "destructive";

export interface AppSourceMeta {
  label: string;
  variant: AppSourceVariant;
}

const META: Record<AppSource, AppSourceMeta> = {
  appStore: { label: "App Store", variant: "secondary" },
  abm: { label: "Apps & Books", variant: "default" },
  private: { label: "Upload", variant: "outline" },
  macOSCatalog: { label: "macOS Catalog", variant: "secondary" },
  custom: { label: "Custom", variant: "outline" },
};

const FALLBACK: AppSourceMeta = { label: "Unknown", variant: "outline" };

export function getAppSourceMeta(source: AppSource | string | undefined | null): AppSourceMeta {
  if (!source) return FALLBACK;
  // Treat legacy "public" as App Store
  if (source === "public") return META.appStore;
  return META[source as AppSource] ?? FALLBACK;
}
